/**
 * Mesma classe de risco do status: se a API devolver o role com caixa
 * diferente (ex.: "Admin"), comparações diretas contra literais minúsculos
 * fazem o usuário cair silenciosamente em permissões ou rotas erradas.
 */
export function normalizeRole(role: string | null | undefined): string {
  return (role ?? '').trim().toLowerCase();
}

export function hasRole(roles: string[] | null | undefined, ...names: string[]): boolean {
  const normalizedNames = names.map(normalizeRole);
  return (roles ?? []).some(r => normalizedNames.includes(normalizeRole(r)));
}
